<app-selector label="Ordering" [data]="orderingCoreService.orderingList$| async" displayKey="name"
    [formControl]="ctrl" hintStyle="margin-left: -14px; margin-top: -5px" (refreshEvent)="refresh()" [loading]="orderingCoreService.loading" [hint]="hint">
</app-selector>
